module.exports = __webpack_public_path__ + "daec36499ec9f7dc72805c469e512abd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_35.jpg
// module id = 1709
// module chunks = 5